<template>
  <div class="p-terms">
    <h2 class="p-terms__title mb-l">
      {{
        request
          ? "Вы&#8201;зарегистрированы на&nbsp;мероприятие:"
          : "Как принять участие?"
      }}
    </h2>
    <template v-if="request">
      <p v-if="eventTitle" class="p-terms__event-title">
        {{ eventTitle }}
      </p>
      <div class="p-terms__button-box mb-l">
        <BaseButton
          tag="a"
          :href="requestLink"
          target="_blank"
          rel="noopener noreferrer"
          class="p-terms__button"
          >Перейти к заявке</BaseButton
        >
      </div>
    </template>
    <div v-else class="p-terms__steps-box mb-l">
      <RegistrationStep />
      <OrganizationStep />
      <PlatformStep @openModal="openVenueModal" />
      <RequestStep :request="request" />
    </div>
    <p v-if="!user" class="p-terms__results mt-s mb-l">
      Зарегистрируйтесь на&nbsp;<a
        :href="loginURL"
        title="Платформа Талант"
        class="link-text"
        @click="$emit('handleLoginClick', $event)"
        >платформe &laquo;Талант&raquo;</a
      >, чтобы принять участие в&nbsp;конкурсе.
    </p>

    <div v-if="user && !request">
      <OrganizationSelect id="org-select" />
      <PlatformSelect @openModal="openVenueModal" />
      <BaseButton
        v-if="selectedOrganization && selectedPlatform"
        tag="a"
        href="#tracks"
        class="p-terms__req-button"
        >Создать заявку</BaseButton
      >
    </div>

    <div class="p-terms__button-box">
      <BaseButton
        v-if="!user"
        tag="a"
        :href="loginURL"
        class="p-terms__button"
        @click="$emit('handleLoginClick', $event)"
        >Регистрация</BaseButton
      >
    </div>
  </div>
</template>

<script>
import RegistrationStep from "./participationSteps/RegistrationStep.vue";
import OrganizationStep from "./participationSteps/OrganizationStep.vue";
import PlatformStep from "./participationSteps/PlatformStep.vue";
import RequestStep from "./participationSteps/RequestStep.vue";
import OrganizationSelect from "./participationSteps/OrganizationSelect.vue";
import PlatformSelect from "./participationSteps/PlatformSelect.vue";
import VenueModal from "../modals/VenueModal.vue";

export default {
  name: "ParticipationTerms",
  components: {
    RegistrationStep,
    OrganizationStep,
    PlatformStep,
    RequestStep,
    OrganizationSelect,
    PlatformSelect,
  },
  props: {
    user: Object,
  },
  computed: {
    request() {
      return this.$store.state.requestPreparing.requests[0];
    },
    selectedOrganization() {
      return this.$store.state.requestPreparing.selectedOrganization;
    },
    selectedPlatform() {
      return this.$store.state.requestPreparing.selectedPlatform;
    },
    eventTitle() {
      const { request } = this;
      if (!request || !request.event) return;
      return request.event.title || request.event.alt_title;
    },
    requestLink() {
      if (!this.request) return;
      return `${process.env.VUE_APP_TALENT_HOST}/events/requests/${this.request.id}`;
    },
    loginURL() {
      let next = window.location.origin + process.env.VUE_APP_ROOT_PREFIX;
      const from = this.$route.query.from || "/";
      return (
        process.env.VUE_APP_TALENT_HOST + `/signin?redirect_uri=${next}${from}`
      );
    },
  },
  methods: {
    openVenueModal(platform) {
      this.$modal.show(
        VenueModal,
        {
          venue: platform || this.selectedPlatform,
        },
        {
          adaptive: true,
          scrollable: true,
          height: "auto",
          minHeight: NaN,
          width: 800,
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.p-terms {
  &__title {
    font-size: @font-size-h2;
    line-height: @line-height-h2;
    max-width: 720px;
    text-align: center;
    font-weight: 700;
    margin: 0 auto;
  }

  &__event-title {
    font-size: @font-size-h4;
    line-height: @line-height-h4;
    max-width: 720px;
    text-align: center;
    font-weight: 700;
    margin: 0 auto @margin-m;
  }

  &__steps-box {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    flex-wrap: wrap;
    gap: 10px;
  }

  &__description {
    padding: 30px;
    width: 100%;
    border-radius: @border-radius-xs;
    border: 1px solid @blue-color;
    background-color: #fff;
    margin-bottom: @margin-l;

    &-title {
      font-size: @font-size-l;
      line-height: @line-height-l;
      font-weight: bold;
      margin-bottom: @margin-s;
    }
  }
  &__results {
    text-align: center;
  }

  &__button-box {
    display: flex;
    justify-content: center;
  }

  &__req-button {
    display: flex !important;
    width: max-content;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
  }

  @media (max-width: @screen-xs) {
    &__title {
      font-size: @font-size-h4;
      line-height: @line-height-h4;
    }
    &__event-title {
      font-size: @font-size-l;
      line-height: @line-height-l;
    }
  }

  @media (max-width: @screen-xs-max) {
    &__description {
      padding: 20px;
    }
    &__steps-box {
      grid-template-columns: 1fr;
    }
    &__button {
      width: 100%;
    }
  }
}
</style>
